
import { Link } from 'react-router-dom';

const categories = [
  {
    id: 1,
    name: 'العناية بالبشرة',
    description: 'منتجات طبيعية لبشرة نضرة ومشرقة',
    image: 'https://public.readdy.ai/ai/img_res/89905b15be5214dea97b45e8ace65073.jpg',
    link: '/skincare',
    icon: 'ri-heart-pulse-line'
  },
  {
    id: 2,
    name: 'المكياج',
    description: 'ألوان رائعة لإطلالة مثالية',
    image: 'https://readdy.ai/api/search-image?query=makeup%20products%20collection%20lipstick%20eyeshadow%20palette%20blush%20on%20soft%20pink%20background%2C%20luxury%20cosmetics%20flatlay%2C%20elegant%20beauty%20photography%2C%20rose%20gold%20accents%2C%20minimalist%20feminine%20aesthetic%2C%20professional%20product%20display&width=600&height=700&seq=cat2&orientation=portrait',
    link: '/makeup',
    icon: 'ri-brush-line'
  },
  {
    id: 3,
    name: 'العناية بالجسم',
    description: 'نعومة وترطيب لجسمك',
    image: 'https://readdy.ai/api/search-image?query=body%20care%20products%20lotion%20cream%20bottles%20on%20soft%20pink%20background%2C%20luxury%20spa%20aesthetic%2C%20elegant%20beauty%20product%20photography%2C%20minimalist%20style%20with%20natural%20elements%2C%20professional%20cosmetic%20display%2C%20feminine%20and%20clean&width=600&height=700&seq=cat3&orientation=portrait',
    link: '/bodycare',
    icon: 'ri-drop-line'
  },
  {
    id: 4,
    name: 'العطور',
    description: 'روائح فاخرة تعكس شخصيتك',
    image: 'https://readdy.ai/api/search-image?query=luxury%20perfume%20bottles%20with%20pink%20rose%20mist%20on%20elegant%20soft%20background%2C%20sophisticated%20fragrance%20photography%2C%20minimalist%20beauty%20aesthetic%2C%20feminine%20style%20with%20rose%20petals%2C%20professional%20product%20display%2C%20romantic%20lighting&width=600&height=700&seq=cat4&orientation=portrait',
    link: '/fragrance',
    icon: 'ri-flask-line'
  }
];

const FeaturedCategories = () => {
  return (
    <section className="py-20 bg-white" dir="rtl">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
            تسوقي حسب الفئة
          </h2>
          <p className="text-gray-600">اكتشفي مجموعتنا المتنوعة من منتجات التجميل الفاخرة</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={category.link}
              className="group relative overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <div className="w-12 h-12 flex items-center justify-center bg-rose-400/90 rounded-full mb-3">
                  <i className={`${category.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold mb-2">{category.name}</h3>
                <p className="text-sm text-white/90 mb-3">{category.description}</p>
                <span className="inline-flex items-center gap-2 text-sm font-medium group-hover:gap-3 transition-all">
                  تسوقي الآن
                  <i className="ri-arrow-left-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCategories;
